export default "__VITE_ASSET__BS5kt10j__"